/**
 * Mirrors `aliasKey` in sc-platform core (resolveSubject.ts) — the comparison
 * key the resolver and the API's duplicate guard both use. "M-Series",
 * "m series", and "M  Series" are one key; "M302" stays distinct from "M 303".
 * The live duplicate check here must warn on exactly what the API would
 * reject, so the normalization is copied, not approximated.
 */
const ARTICLE_TOKENS = new Set(['the', 'a', 'an']);

export const aliasKey = (text: string): string => {
  const normalized = text
    .toLowerCase()
    .replace(/([a-z])([0-9])/g, '$1 $2')
    .replace(/([0-9])([a-z])/g, '$1 $2')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
  const tokens = [...new Set(normalized.split(/\s+/).filter((t) => t.length > 0))];
  // Articles carry no identity ("The Travis" ≡ "Travis") — dropped only while
  // other tokens remain, matching the API's key exactly.
  const meaningful = tokens.filter((t) => !ARTICLE_TOKENS.has(t));
  return (meaningful.length > 0 ? meaningful : tokens).sort().join(' ');
};
